
import React, { useEffect } from "react";
import "./Popup.css";
import Logo from "../Images/Logo.webp";

function Popup() {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    const previousHtmlOverflow =
      document.documentElement.style.overflow;

    // Lock page scrolling
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    // Restore scrolling when popup unmounts
    return () => {
      document.body.style.overflow = previousOverflow;
      document.documentElement.style.overflow =
        previousHtmlOverflow;
    };
  }, []);

  return (
    <div className="popup__overlay">
      <div
        className="popup__container"
        role="dialog"
        aria-modal="true"
        aria-labelledby="popup-heading"
      >
        <div className="popup__side__bar">
          <div className="popup__title">
            <h3 id="popup-heading"></h3>

            <span className="popup__subtitle">
              Bliss Life Solutions is currently not
              accepting new clients.
            </span>
          </div>

          <span className="popup__text">
            Thank you to our community for your ongoing
            support and understanding.
          </span>
        </div>

        <img
          src={Logo}
          alt="Bliss Life Solutions logo"
          className="popup__image"
        />
      </div>
    </div>
  );
}

export default Popup;
